import {
  Alert,
  AppBar,
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from '@mui/material';
import { useAuth } from '../../../hooks/useAppContext';
import { useNavigate } from 'react-router-dom';
import {
  KeyboardArrowDown,
  LockOutlined,
  Logout,
  Menu as MenuIcon,
  PersonOutline,
} from '@mui/icons-material';
import logo from '../../../assets/SVG/logo.png';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProfileData } from '../../../redux/reducers/profileSlice';
import { fetchProjectProfileData } from '../../../redux/reducers/projectProfileSlice';
import socket from '../../../socket';
import { SocketResponse } from '../../../types';
import dayjs from 'dayjs';
import axios from 'axios';
import { toast } from 'react-toastify';
import ChangePasswordModal from '../../ChangePassword';
interface HeaderProps {
  drawerToggler: () => void;
}
interface ChangePasswordValues {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}
const Header: React.FC<HeaderProps> = ({ drawerToggler }) => {
  const { logout, isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const profile = useSelector((state: any) => state.profileSlice.profile)
  const loading = useSelector((state: any) => state.profileSlice.loading);
  const [isAlert, setIsAlert] = useState(false)
  const [Expirationdays, setExpirationdays] = useState<number>(0)
  const [hasAlertBeenShown, setHasAlertBeenShown] = useState<boolean>(false);
  const projectProfile = useSelector((state: any) => state.projectProfileSlice.projectProfile)
  const dispatch = useDispatch()
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [openResetPasswordModal, setOpenResetPasswordModal] = useState(false);
  const menuOpen = Boolean(menuAnchor);
  useEffect(() => {
    dispatch(fetchProfileData() as any)
    dispatch(fetchProjectProfileData() as any);
  }, [dispatch])
  useEffect(() => {
    localStorage.setItem('projectOP', profile?.data?.projectId);
  }, [loading])


  // Check if the alert has been shown before on initial load
  useEffect(() => {
    const alertStatus = localStorage.getItem('expirationAlertShown');
    if (alertStatus === 'true') {
      setHasAlertBeenShown(true);
    }
  }, []);
  useEffect(() => {
    if (!profile?.data?.projectId) return;

    const projectId = profile.data.projectId.toString();

    const handleProfileUpdate = (data: SocketResponse) => {

      if (data.module === 'profile' && data.operation === 'update') {
        dispatch(fetchProfileData() as any);
        dispatch(fetchProjectProfileData() as any);
      }
    };


    socket.on(projectId, handleProfileUpdate);

    // Cleanup on unmount or when project ID changes
    return () => {
      socket.off('connect');
      socket.off('disconnect');
      socket.off(projectId, handleProfileUpdate);
    };
  }, [profile?.data?.projectId, dispatch]);
  const [imageError, setImageError] = useState<boolean>(false);

  const handleImageError = () => {
    setImageError(true);
  };
  const closeMenu = () => setMenuAnchor(null);
  const handleLogout = () => {
    closeMenu();
    if (isLoggedIn) {
      localStorage.removeItem("expirationAlertShown")
      logout();
      navigate('/');
    }
  };
  const handlePasswordChange = (values: ChangePasswordValues) => {
    let data = JSON.stringify({
      oldPassword: values?.oldPassword,
      newPassword: values?.newPassword,
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/auth/changePassword`,
      headers: {
        accept: '*/*',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        if (response?.data?.isSuccess) {
          toast.success(response?.data?.message);
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const isAdmin = Boolean(profile?.data?.userType?.includes('admin'));
  const displayName = isAdmin
    ? [profile?.data?.firstName, profile?.data?.lastName].filter(Boolean).join(' ').trim()
    : (profile?.data?.fullName || '').trim();
  const profileReady = !loading && Boolean(profile?.data) && Boolean(displayName);
  const welcomeName = profileReady ? `Welcome, ${displayName}` : '';
  const checkDateAlert = (providedDate: string) => {
    const currentDate = dayjs();
    const providedDateTime = dayjs(providedDate);
    const differenceInDays = providedDateTime.diff(currentDate, 'day');
    setExpirationdays(differenceInDays)
    if (differenceInDays <= 20 && differenceInDays >= 1) {
      setIsAlert(true);
    } else {
      setIsAlert(false);
    }
  };
  const handleCloseAlert = () => {
    setIsAlert(false);
    localStorage.setItem('expirationAlertShown', 'false'); // Set flag to indicate the alert has been shown
  };
  useEffect(() => {
    if (hasAlertBeenShown) {
      checkDateAlert(projectProfile?.contractExpiryDate)
    }

  }, [projectProfile])

  return (

    <Box sx={{ flexGrow: 1 }}>
      {isAlert && Expirationdays !== null && (
        <Box sx={{ width: "100vw", position: "fixed", display: "flex", justifyContent: "center", zIndex: "2", top: "0", left: "0", right: "0" }}>
        
          <Alert severity="warning" onClose={handleCloseAlert}>
          Your subscription will expire in{" "}
            <span style={{ fontWeight: "bold" }}>
              {Math.abs(Expirationdays || 0)} day{Expirationdays > 1 ? "s" : ""}
            </span>
            . Please renew in advance to avoid service interruption. For renewal assistance,
            contact us at{" "}
            <span style={{ fontWeight: "bold" }}>info.pakhims@gmail.com</span> or{" "}
            <span style={{ fontWeight: "bold" }}>+92 302 8876298</span>.
          </Alert>

        </Box>
      )}
      <AppBar position='static'>
        <Toolbar>
          <IconButton
            size='large'
            edge='start'
            color='inherit'
            aria-label='open drawer'
            sx={{ mr: 2 }}
            onClick={() => drawerToggler()}
          >
            <MenuIcon />
          </IconButton>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              margin: 'auto',
            }}
          >
            <Typography
              variant='h6'
              noWrap
              component='div'
              sx={{ flexGrow: 1, display: { xs: 'none', sm: 'none', md: 'block' } }}
            >

              {projectProfile?.hospitalLogoUrl ? <img src={projectProfile?.hospitalLogoUrl} alt={projectProfile?.hospitalName + ' logo'} style={{ height: '40px', cursor: 'pointer' }} onClick={() => navigate('/')} onError={handleImageError} /> : <img src={logo} style={{ height: '40px', cursor: 'pointer' }} onClick={() => navigate('/')} />}

            </Typography>
            <Typography
              variant='h6'
              noWrap
              component='div'
              sx={{ flexGrow: 1, display: { xs: 'none', lg: 'block', sm: 'none' }, textTransform: 'uppercase' }}
            >
              {projectProfile?.hospitalName}
            </Typography>
            {isLoggedIn && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {profileReady && (
                  <Typography variant='h6' sx={{ fontSize: { lg: '1.25rem', md: '1rem', xs: '0.8rem' }, textTransform: 'capitalize' }}>
                    {welcomeName}
                  </Typography>
                )}
                <IconButton
                  color="inherit"
                  onClick={(e) => setMenuAnchor(e.currentTarget)}
                  aria-controls={menuOpen ? 'account-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={menuOpen ? 'true' : undefined}
                  sx={{
                    border: '1px solid rgba(255,255,255,0.35)',
                    borderRadius: '10px',
                    ml: 1,
                    px: 0.6,
                  }}
                >
                  <PersonOutline />
                  <KeyboardArrowDown fontSize="small" />
                </IconButton>
                <Menu
                  id="account-menu"
                  anchorEl={menuAnchor}
                  open={menuOpen}
                  onClose={closeMenu}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  PaperProps={{
                    sx: {
                      mt: 1,
                      minWidth: 200,
                      borderRadius: '12px',
                      boxShadow: '0 12px 30px rgba(15, 55, 110, 0.16)',
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      closeMenu();
                      navigate('/');
                    }}
                  >
                    <ListItemIcon>
                      <PersonOutline fontSize="small" />
                    </ListItemIcon>
                    Profile
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      closeMenu();
                      setOpenResetPasswordModal(true);
                    }}
                  >
                    <ListItemIcon>
                      <LockOutlined fontSize="small" />
                    </ListItemIcon>
                    Change Password
                  </MenuItem>
                  <Divider />
                  <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                      <Logout fontSize="small" />
                    </ListItemIcon>
                    Logout
                  </MenuItem>
                </Menu>
              </Box>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <ChangePasswordModal
        open={openResetPasswordModal}
        onClose={() => setOpenResetPasswordModal(false)}
        handleSubmit={handlePasswordChange}
      />
    </Box>
  );
};
export default Header;
